// @ts-nocheck
import React, { useEffect, useState } from 'react';
import {
  Grid,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import {
  SecondaryButton,
  PrimaryButton,
} from 'components/__v2__/Button/ReusableButton';
import { LocationOnIcon } from 'assets/icons';
import PreviewMap from '../../../components/PreviewMap';
import { useGooglePlaces } from 'hooks/common';
import { Logger } from 'utils/logger';

const AddressPreview = ({
  field,
  tableId,
  tableType,
  rowIndex,
  colIndex,
  updateAnswer,
  updateAnswerInPrefilledElements,
  shouldBeReadOnly,
}) => {
  const [openMapDialog, setOpenMapDialog] = useState(false);
  const [marker, setMarker] = useState(null);
  const [address, setAddress] = useState(null);

  useEffect(() => {
    if (field.answer) {
      setAddress(field.answer);
    }
  }, [field.answer]);

  const { getGeocodeByLatLng } = useGooglePlaces();

  const handleMapClick = (lat, lng) => {
    const location = { lat, lng };
    setMarker(location);
  };

  const handleDialogClose = async () => {
    if (marker) {
      const result = await getGeocodeByLatLng(marker.lat, marker.lng);
      const address = result[0]?.formatted_address;
      if (address) {
        setAddress(address);
        updateAnswer(tableId, rowIndex, colIndex, address);
        if (updateAnswerInPrefilledElements) {
          updateAnswerInPrefilledElements(tableId, address, tableType, '', {
            rowIndex,
            colIndex,
            tableElementType: field?.type,
          });
        }
      } else {
        Logger.error({
          message: 'Failed to fetch address from geocoding service',
          data: { marker },
        });
      }
    }
    setOpenMapDialog(false);
  };

  const handleBlur = () => {
    updateAnswer(tableId, rowIndex, colIndex, address);
    if (updateAnswerInPrefilledElements) {
      updateAnswerInPrefilledElements(tableId, address, tableType, '', {
        rowIndex,
        colIndex,
        tableElementType: field?.type,
      });
    }
  };

  return (
    <>
      <Grid display="flex" alignItems="center" gap={1}>
        <TextField
          name="Address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          onBlur={handleBlur}
          variant="outlined"
          fullWidth
          placeholder="Your address"
          disabled={shouldBeReadOnly}
        />
        <IconButton onClick={() => setOpenMapDialog(true)}>
          <LocationOnIcon />
        </IconButton>
      </Grid>
      <Dialog
        open={openMapDialog}
        onClose={() => setOpenMapDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          {shouldBeReadOnly ? 'View Location' : 'Select Location'}
        </DialogTitle>
        <DialogContent>
          <PreviewMap location={marker} onMapClick={handleMapClick} />
        </DialogContent>
        {!shouldBeReadOnly && (
          <DialogActions>
            <SecondaryButton
              onClick={() => setOpenMapDialog(false)}
              variant="outlined"
              size="small"
            >
              Cancel
            </SecondaryButton>
            <PrimaryButton onClick={handleDialogClose} color="primary">
              Confirm
            </PrimaryButton>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};

export default AddressPreview;
